import { FaMugHot } from "react-icons/fa6";
import { FaCoffee, FaCookie, FaCouch, FaHeart } from "react-icons/fa";

import images from "./images";

const About = {
    sub: "About Us",
    heading: "Your Most Favorite Local Coffee Spot",
    description: [
        "Welcome to Brewtopia, your cozy corner for exceptional coffee and freshly baked pastries. We're dedicated to creating a warm and inviting space where everyone feels at home. With over 35 years of experience, we bring passion and quality to every cup we serve."
    ],
    experience: {
        icon: <FaMugHot />,
        year: 35,
        text: 'years of experience',
    },
    points: [
        {
            icon: <FaCoffee />,
            title: "Premium Quality Coffee",
        },
        {
            icon: <FaCouch />,
            title: "Warm & Cozy Ambiance",
        },
        {
            icon: <FaCookie />,
            title: "Freshly Baked Pastries",
        },
        {
            icon: <FaHeart />,
            title: "Community-Focused Service",
        },
    ],
    image: {
        src1: images.about1,
        src2: images.about2,
        alt1: "About-Image1",
        alt2: "About-Image2",
    },
    button: {
        text: "Book Table",
        link: "Booking"
    }
};

export default About;